export default __webpack_public_path__ + "static/media/logo.13df3be2.png";